import { type SVGProps, useId } from 'react'

import { type CommonIcon, type LinkedinIcon, stackDict } from './keys'

export function StackIcon({
	fill = 'currentcolor',
	width = '1em',
	height = width,
	icon,
	label,
	stack = 'common',
	...props
}: SVGProps<SVGSVGElement> & {
	icon: CommonIcon | LinkedinIcon
	label?: string
	stack?: keyof typeof stackDict
}) {
	const id = useId()

	const a11yProps = label
		? { 'aria-labelledby': id, role: 'img' }
		: { 'aria-hidden': true }

	return (
		<svg fill={fill} height={height} width={width} {...a11yProps} {...props}>
			{label && <title id={id}>{label}</title>}

			<use href={`${stackDict[stack]}#${icon}`} />
		</svg>
	)
}
